import { Link } from "@tanstack/react-router";

/**
 * The Solberegning mark: a sun half-hidden behind a ridge, which is the whole
 * product in one picture. The ridge takes the text colour, so it follows the
 * theme; the sun stays sun yellow in both.
 */
export function BrandMark({ className = "h-7 w-7" }: { className?: string }) {
	return (
		<svg viewBox="0 0 32 32" className={className} aria-hidden="true">
			<circle cx="19" cy="14.5" r="6.5" fill="var(--c-sun)" />
			<path d="M1 27 L10 14 L14.5 19.5 L19 16 L23.5 21 L26 18.5 L31 24 L31 27 Z" fill="currentColor" />
		</svg>
	);
}

/** Mark + wordmark, linking home. */
export function BrandLink() {
	return (
		<Link
			to="/"
			className="-ml-1 flex items-center gap-2 rounded-lg px-1 py-1 text-ink"
			aria-label="Solberegning – til forsiden"
		>
			<BrandMark />
			<span className="text-[17px] font-bold tracking-[-0.02em]">Solberegning</span>
		</Link>
	);
}
